import { object, string } from 'yup';

const passwordValidationMessage = '8文字以上64文字以下、英小文字・英大文字・数字を1文字以上含めて入力してください。';

const passwordSchema = object({
    password: string()
        .required('パスワードを入力してください。')
        .min(8, passwordValidationMessage)
        .max(64, passwordValidationMessage)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]+$/, passwordValidationMessage)
});

export default passwordSchema;
